import Allergies from './Allergies';

export default Allergies;
